import { ICompany } from "../../interfaces/company";
import { ActionType } from "../actions/action";
import { company } from "../actions/actionContants";

export interface ICompanyState {
	companies: ICompany[];
	isLoaded: boolean;
}

const INIT_STATE: ICompanyState = {
	companies: [],
	isLoaded: false
};

export default function (
	state: ICompanyState = INIT_STATE,
	action: ActionType
) {
	switch (action.type) {
		case company.GET_COMPANY_RESPONSE:
			return {
				...state,
				companies: action.payload,
				isLoaded: true
			};
		default:
			return state;
	}
}
